import {
  TRIGGER_RANDOM_ANIMATION
} from '@flow/store/animation/constants';

const initialState: any = {
  animationIndex: -1,
};

const animationReducer = (state = initialState, action: any) => {
  const {
    type,
    animationIndex
  } = action;

  switch (type) {
    case TRIGGER_RANDOM_ANIMATION: {
      return {
        animationIndex,
      };
    }
    default:
      return state;
  }
};

export {
  animationReducer,
};


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/animation/reducer.ts